import { doc, updateDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

import { getAuth } from 'firebase/auth';

export async function submitJuzSelection(hatmId, chosenJuzs, name, state) {
  const auth = getAuth();
  const isAuthenticated = auth.currentUser !== null;
  
  try {
    let chosenJuzsData = {};
    chosenJuzs.forEach((juz) => {
      chosenJuzsData[juz] = {
        fullName: name,
        ...(isAuthenticated && { userId: auth.currentUser.uid })
      };
    });

    // Update hatm document
    await setDoc(
      doc(db, "hatms", hatmId),
      {
        juzs: { ...chosenJuzsData, ...state.juzs },
      },
      { merge: true }
    );

    // Update user document only if authenticated
    if (isAuthenticated) {
      const hatmData = {};
      chosenJuzs.forEach((juz) => {
        hatmData[`hatms.${hatmId}.${juz}`] = { read: false };
      });

      await updateDoc(
        doc(db, "users", auth.currentUser.uid),
        hatmData
      );
    }

    return true;
  } catch (error) {
    console.error("Error submitting juz selection:", error);
    throw error;
  }
} 